import { Field, NumericInput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetBalanceFieldSet, WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { valueOrDefault } from 'Lib/Any';
import React from 'react';
import { useSelector } from 'react-redux';
import { pipe } from 'rxjs';
import WholePortionStandardOvenDryMultiTraySection from './WholePortionStandardOvenDryMultiTraySection';
import WholePortionStandardOvenDrySingleTraySection from './WholePortionStandardOvenDrySingleTraySection';

let WholePortionStandardOvenDryPreparationSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const lightweightAggregate: boolean = useSelector(
    pipe(createWorksheetSelector!('data.Preparation.LightweightAggregate', false), valueOrDefault(false))
  );

  const singleTray = useSelector(pipe(createWorksheetSelector!('DryingTrays'), (p) => p?.length < 2));

  return (
    <>
      <ListFieldSection>
        <WorksheetBalanceFieldSet name="Equipment.Balance" />
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="oven" name="Equipment.Oven" />
      </ListFieldSection>
      <ListFieldSection>
        <Field input={<NumericInput />} name="Measurements.BulkDensity" visible={lightweightAggregate} />
      </ListFieldSection>

      {singleTray ? <WholePortionStandardOvenDrySingleTraySection /> : <WholePortionStandardOvenDryMultiTraySection />}
    </>
  );
};

WholePortionStandardOvenDryPreparationSection = withInjectedProps(WholePortionStandardOvenDryPreparationSection);

export { WholePortionStandardOvenDryPreparationSection };
export default WholePortionStandardOvenDryPreparationSection;
